import React, { useEffect } from "react";
import { Button, DialogContent, Stack,Chip } from "@mui/material";
import { stackFlexColumn } from "../../../../utils/MUIShortcuts";
import { ContentLabel, Label, Title } from "../../../main/query/topic/products/product-detail.styled";
import { useCallback } from "react";
import palette from "../../../../theme/palette";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styled from "styled-components";
import { handlePromise } from "../../../../utils/handlePromisse";
import { getClassifications } from "../../../../services/userClassificationsService";
import { useState } from "react";
import { saveClassification } from "../../../../services/oralService";
import { SimpleSnackbar } from "../../../../components/snackbar";
import { UserClassificationsDialog } from "../../../main/query/oral/activesOral/userClassifications.dialog";
import { getPeriodLabel } from "../../../../utils/period-label";


export type Details = {
    id?: number
    name?: string
    mechanism?: string
    description?: string
    min?: string
    max?: string
    source?: string
    period?: string
    unity?: string
    classifications?: string[]
    userClassifications?: string[]
    favorite?: boolean,
    annotation?: string,
}

export const ClassificationChip = styled(Chip)`
    margin: 2px;
    min-width: 120px;
    max-width: 150px;
    display: flex;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

type Props = {
    onClose: () => void
    detail: Details
}

export const OralDetail: React.FC<Props> = ({ detail, onClose, }) => {
    const [classification, setClassification] = useState<string[]>([]);
    const [userClassification, setUserClassification] = useState<string[]>([]);
    const [activeSelected, setActiveSelected] = useState<Details|null>(null)
    const [showSnackbar, setShowSnackbar] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [classificationsOpen, setClassificationsOpen] = useState(false)
    const [text, setText] = useState<string[]>([])

    const fetchClassifications = useCallback(async () => {
        if (detail.id) {
            const [result, _] = await handlePromise(getClassifications(detail.id));
            setUserClassification(result.data.userClassifications);
            setClassification(result.data.classifications);
        }
    }, [detail.id, setClassification, setUserClassification]);

    const handleClassification = useCallback(async(active: Details) => {
        if (userClassification) {
            setText(userClassification);
        }
            setActiveSelected(active)
            setClassificationsOpen(true)
        },[setActiveSelected, userClassification])

    const deleteClassification = useCallback(async (classificationToRemove: string, active: Details) => { 
        setActiveSelected(active);
        
        if (!userClassification || userClassification.length === 0) {
            setShowSnackbar(true);
            setSnackbarMessage("Erro ao encontrar a classificação do usuário");
        }
        
        const updatedClassifications = userClassification.filter((classification) => classification !== classificationToRemove);
        
        if (!active.id) return;
        
            const [_, error] = await handlePromise(saveClassification(active.id, updatedClassifications));
        
            if (error) {
                setShowSnackbar(true);
                setSnackbarMessage("Erro ao deletar a Classificação do usuário");
                return;
            }
        
            fetchClassifications();
            setClassificationsOpen(false);
        }, [saveClassification, userClassification]);  
        
    const classificationSave = useCallback(async(newClassification: string[]) => {
            if (!activeSelected?.id) return;
        
            if (userClassification) {
                const [_, error] = await handlePromise(saveClassification(activeSelected?.id, newClassification))
                if (!!error) {
                    setShowSnackbar(true)
                    setSnackbarMessage("Erro ao salvar Classificações")
                    return
                    }
                }
        
                fetchClassifications()
                setClassificationsOpen(false)
        },[activeSelected, saveClassification])

    useEffect(() => {
        fetchClassifications()
    },[fetchClassifications])

    const createLabel = (label: string, value?: string) => {
        return <>{value && <ContentLabel><Label>{label}</Label> {value}</ContentLabel>}</>
    }

    const renderTags = useCallback(() => {
        return classification?.map((option, index) => (
            <Chip
                sx={{marginLeft: '3px', minWidth: '120px', marginTop: '3px', backgroundColor: palette.secondary.main}}
                key={index}
                label={option}
                color={'primary'}
            />
        ));
    }, [classification]);

    const tags = renderTags();

    return (
        <>
            <DialogContent>
                <Stack {...stackFlexColumn('center', 'flex-start')} spacing={2} sx={{ width: '100%', flexWrap: 'wrap' }}>
                    <Title>{detail.name}</Title>
                    
                    {createLabel("MECANISMO DE AÇÃO:", detail.mechanism)}
                    {createLabel("DESCRIÇÃO:", detail.description)}
                    {createLabel("DOSAGEM USUAL:", `${detail.min} a ${detail.max} ${detail.unity}`)}
                    {createLabel("PERÍODO:", getPeriodLabel(detail.period))}
                    {createLabel("MINHA ANOTAÇÃO:", detail.annotation)}
                    {createLabel("FONTE:", detail.source)}

                    <ContentLabel style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', }}>
                        <Label>CLASSIFICAÇÕES:</Label> 
                        {tags}
                    
                    </ContentLabel>

                    <ContentLabel style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        <Label>CLASSIFICAÇÃO DO USUÁRIO:</Label> 
                            <Button size="small" sx={{ minWidth: '30px', minHeight: '30px', marginLeft: '5px' }} onClick={() => handleClassification(detail)}>
                                <AddCircleOutlineIcon style={{ color: palette.secondary.main }} />
                            </Button>

                            {
                                userClassification?.map((item, index) => (
                                    <ClassificationChip
                                        key={index}
                                        label={item}
                                        color="secondary"
                                        onDelete={() => deleteClassification(item, detail)}
                                    />
                                ))
                            }

                    </ContentLabel>

                    <SimpleSnackbar
                        show={showSnackbar}
                        message={snackbarMessage}
                        onDismiss={() => setShowSnackbar(false)}
                     />

                    {
                        classificationsOpen && <UserClassificationsDialog
                            open={classificationsOpen}
                            onClose={() => setClassificationsOpen(false)}
                            externalObservations={text}
                            onSaveClassification={classificationSave}
                                        />
                    }
                        
                    <Button
                        fullWidth={true}
                        size={"large"}
                        onClick={onClose}
                        variant="outlined">FECHAR</Button>
                </Stack>
            </DialogContent>
        </>
    )
}